// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CVds","largestCol":"styles_largestCol__2dGXq","smallestCol":"styles_smallestCol__3U_Zj"};